import { State } from '@progress/kendo-data-query';
import { toODataString } from '@progress/kendo-data-query/dist/npm/odata.operators';
import { ODataResponse } from 'src/types/oDataResponse';
import { Vendor } from 'src/types/vendor';
import { get } from './Api';

async function getVendors(filter: State): Promise<ODataResponse<Vendor>> {
  return get<ODataResponse<Vendor>>(`/odata/vendor?${toODataString(filter, { utcDates: false })}`);
}

async function getVendorByNumber(vendorNumber: string | number): Promise<ODataResponse<Vendor>> {
  let venNum: string = vendorNumber.toString();

  let filter = {
    take: 1,
    filter: {
      logic: 'or',
      value: '',
      filters: [{ field: 'numberString', operator: 'eq', value: venNum }],
    },
  } as State;

  return get<ODataResponse<Vendor>>(`/odata/vendor?${toODataString(filter, { utcDates: false })}`);
}

export default {
  getVendors,
  getVendorByNumber,
};
